import {
  GAME_SPINNERS_JOIN, GAME_SPINNERS_EXPIRE, GAME_SPINNERS_CREATE, GAME_SPINNERS_REQUEST_BOT,
} from '@/utils/constants/api-endpoints'
import socket from '@/plugins/socket'

export const join = (id, color) => socket.request(GAME_SPINNERS_JOIN, { id, color })
export const requestBot = (id, color) => socket.request(GAME_SPINNERS_REQUEST_BOT, { id, color })
// export const join = (id, color) => socket.request('game.spinners.fakeJoin', { id, color })
export const expire = id => socket.request(GAME_SPINNERS_EXPIRE, id)
export const create = form => socket.request(GAME_SPINNERS_CREATE, form)
